<template>
  <div :class="checkout.shipping_method_code === 'ups' ? 'hided-single-payment' : ''" class="checkout-payment">
    <div class="headline-sm">תשלום</div>
    <payment-item
      v-bind:class="getErrors()['payment_method_code'] ? 'has-error' : ''"
      v-for="(item,idx) in payments"
      :item="item"
      :is-active="isActive(item.code)"
      @change="(e) => $emit('codeChanged', e)"
    />
    <component v-if="activePayment" :is="dataComponent" :model-value="activePayment.data" @change="onDataChanged"></component>
  </div>
</template>

<script>
import PaymentItem from "./payment-item";

export default {
  inject: ['getErrors'],
  name: "CheckoutPayments",
  emits: ['codeChanged', 'onDataChanged'],
  props: {
    checkout: {},
    item: {},
    modelValue: {},
    payments: {
      default: () => []
    }
  },
  components: {PaymentItem},
  data() {
    return {}
  },
  computed: {
    activePayment() {
      if(this.checkout.shipping_method_code === 'ups') {
        //Todo remove after z-credit will work
        this.checkout.payment_method_code = 'zcredit_card'
      }
      return this.payments.find(i => i.code === this.checkout.payment_method_code)
    },
    dataComponent() {
      return this.activePayment?.component
    }
  },
  methods: {
    isActive(code) {
      return this.checkout.payment_method_code === code
    },
    onDataChanged() {
      this.checkout.payment_method_data = this.activePayment.data
      this.$emit('onDataChanged')
    }
  }
}
</script>

<style scoped>
  .hided-single-payment {
    display: none;
  }
</style>
